import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { Projects2Service } from '../../../modules/projects/projects2.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { ProjectReportsService } from '../../../modules/projects/project-reports.service';

@Component({
  selector: 'app-select-project',
  templateUrl: './select-project.component.html',
  styleUrls: ['./select-project.component.scss'],
})
export class SelectProjectComponent implements OnInit, OnDestroy {
  @ViewChild('singleSelect', { static: false }) singleSelect: any; // Reference to dropdown
  searchControl = new FormControl('');
  protected _onDestroy = new Subject<void>();
  @Output() singleSelectChange: EventEmitter<any> = new EventEmitter<any>();
  loading: boolean = false;
  dummyValue: any = null;
  compareProjects = (o1: any, o2: any) => o1?.id === o2?.id;
  @Input() exceptions!: any;

  constructor(
    public _project2: Projects2Service,
    public projectReportService: ProjectReportsService,
  ) {}

  async ngOnInit() {
    await this.searchProjectsSafely(1);

    this.searchControl.valueChanges
      .pipe(debounceTime(700), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (val.toString().length > 2) {
          this.filterProjects();
        } else if (val.toString().length === 0) {
          this.filterProjects();
        }
      }); // Subscribe to changes in the folder search input
  }

  async loadAllOnScroll() {
    if (
      !this.projectReportService.areAllProjectsLoading &&
      this.projectReportService.totalAllProjects > this.projectReportService.allProjects.length
    ) {
      this.singleSelect.disableScrollToActiveOnOptionsChanged = true;
      const nextPage = Math.ceil(this.projectReportService.allProjects.length / 50) + 1;
      await this.searchProjectsSafely(nextPage);
    }
  }

  protected async filterProjects() {
    if (!this.projectReportService.allProjects) {
      return;
    }

    // Get the search keyword
    let search = this.searchControl.value;
    if (!search) {
      // If no search, fetch all projects
      await this.searchProjectsSafely(1);
      return;
    }

    // Trim leading spaces from the search keyword
    search = search.trimStart();

    // If search only has leading spaces (or is empty), do not call the API
    if (!search) {
      return; // Don't call the API if the search only has spaces
    }

    // Proceed with API call if search is valid (no leading spaces and non-empty)
    search = search.toLowerCase();
    await this.searchProjectsSafely(1, search);
  }

  private async searchProjectsSafely(pageNo: number, projectName?: string): Promise<void> {
    this.loading = true;

    try {
      await this.projectReportService.searchProjects(pageNo, projectName);
    } catch {
      // The service already surfaces user-facing errors via toast.
    } finally {
      this.loading = false;
    }
  }

  checkException(id: string) {
    return !this.exceptions.includes(id) && this.dummyValue?.id !== id;
  }

  emitSelection(value) {
    if (!value) {
      return;
    }
    this.dummyValue = value;
    this.singleSelectChange.emit(value);
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
